import {
  createDataReducer,
  getDataReducerInitialState,
} from "@ea/shared_components/redux/reducers/common.data.reducer";

import { ReportTemplate } from "@ea/shared_types/types";
import { moduleActions } from "./reportTemplates.actions";

const initialState = {
  ...getDataReducerInitialState<ReportTemplate>(),
};

export type ReportTemplatesReducer = typeof initialState;

const dataReducer = createDataReducer<ReportTemplate>({
  ...moduleActions.table,
  ...moduleActions.data,
});

export const reducer = dataReducer(initialState);
